export enum actionTypes {
    REQUEST_USER_PROFILE = "request_user_profile",
    RECEIVE_USER_PROFILE = "receive_user_profile",
    UPDATE_USER_PROFILE = "update_user_profile",

    UPDATE_PASSWORD = "update_password",
}
